import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export function ProtectedRoute() {
  const { account, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return <p className="p-10 font-mono text-sm text-muted">Loading…</p>;
  }
  if (!account) {
    // Preserve where the user was headed (path + query) so sign-in returns them
    // there — e.g. a deep link to /loads?equipment=reefer stays intact.
    const target = location.pathname + location.search;
    const to = target && target !== "/" ? `/login?redirect=${encodeURIComponent(target)}` : "/login";
    return <Navigate to={to} replace />;
  }
  return <Outlet />;
}
